import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay } from 'swiper';
SwiperCore.use([Navigation, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {}
      },
      activityList: []
    };
  },
  mounted() {
    this.getActivityList();
  },
  methods: {
    async getActivityList() {
      const now = new Date().getTime();
      const data = await this.$http.getActivityList({});
      this.activityList = data.filter(item => {
        const start = new Date(item.start_time).getTime();
        const end = new Date(item.end_time).getTime();
        return start < now && end > now;
      });
    },
    showDay(end_time) {
      const now = new Date().getTime();
      const end = new Date(end_time).getTime();
      if (now > end) {
        return '0';
      } else {
        return Math.ceil((end - now) / 1000 / 60 / 60 / 24);
      }
    }
  }
};